// src/components/FormularioCancion.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useParams  } from 'react-router-dom';

import {
  Form,
  Input,
  Select,
  Button,
  Progress,
  message,
  Spin,     
} from 'antd';
import {
  getFirestore,
  collection,
  addDoc,
  setDoc,
  updateDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
  arrayUnion,
} from 'firebase/firestore';
 import {
     parsePhoneNumberFromString,
     getCountries,
     getCountryCallingCode
   } from 'libphonenumber-js';

import 'antd/dist/reset.css';
import './FormularioCancion.css';
const { Option } = Select;
const { useWatch } = Form;



// ► Lista de países (ahora incluye también EE.UU.)


 // ► Genera lista de TODOS los países con su ISO, código y emoji de bandera
 const ALL_COUNTRIES = getCountries().map(iso => ({
   iso,
   code: getCountryCallingCode(iso),
   flag: iso
     .toUpperCase()
     .replace(/./g, c => String.fromCodePoint(127397 + c.charCodeAt())),
 }));


const pasos = [
  { key: 'purpose',       label: 'Selecciona el propósito de la canción' },
  { key: 'genre',         label: '¿Qué género deseas?' },
  { key: 'artist',        label: '¿Qué artista te gusta de este género?' },
  { key: 'voiceType',     label: '¿Qué tipo de voz quieres en tu canción?' },
  { key: 'includeName',   label: 'Si quieres que se incluya el nombre o apodo, escríbelo aquí.' },
  { key: 'anecdotes',     label: 'Cuéntanos alguna anécdota o frase que te gustaría incluir.' },
  { key: 'requesterName', label: '¿Cuál es tu nombre?' },
  { key: 'phone',         label: '¿Cuál es tu número de WhatsApp?' },
];



export default function FormularioCancion() {
  const [current, setCurrent]         = useState(0);
  const [submitting, setSubmitting]   = useState(false);
  const [showCustom, setShowCustom]   = useState(false);
  const [phoneExists, setPhoneExists] = useState(false);
  const [form]                        = Form.useForm();
  const { search } = useLocation();
  const { phone: phoneParam } = useParams(); // <-- aquí lees /:phone
  
  const db                            = getFirestore();
  const containerRef                  = useRef(null);
  const [selectedCountry, setSelectedCountry] = useState(
  ALL_COUNTRIES.find(c => c.iso === 'MX') || ALL_COUNTRIES[0]
   );
  // Prefill desde URL: ahora lee 'telefono' y 'nombre'
  useEffect(() => {
    const params = new URLSearchParams(search);
    const tel   = params.get('telefono');
    const nombre = params.get('nombre');
    if (tel) {
      // si viene con prefijo (+, 00) lo limpiamos
      const raw = tel.replace(/\D/g, '');
      form.setFieldsValue({ phone: raw });
    }
    if (nombre) {
      form.setFieldsValue({ requesterName: nombre });
    }


        // Si entraste por /8318790, phoneParam será "8318790"
   if (phoneParam && /^\d+$/.test(phoneParam)) {
     form.setFieldsValue({ phone: phoneParam });
   }
  }, [search, form]);

  // Ajustar iframe height
  const sendHeight = () => {
    if (containerRef.current) {
      const height = containerRef.current.scrollHeight + 20;
      window.parent.postMessage({ type: 'AUTO_HEIGHT', height }, '*');
    }
  };
  useEffect(() => {
    sendHeight();
    window.addEventListener('resize', sendHeight);
    return () => window.removeEventListener('resize', sendHeight);
  }, []);
  useEffect(() => {
    const t = setTimeout(sendHeight, 50);
    return () => clearTimeout(t);
  }, [current, showCustom, submitting]);

  const handleSelectChange = val => {
    setShowCustom(val === 'Otro');
    if (val !== 'Otro') form.setFieldsValue({ purposeCustom: undefined });
  };

  // ► Cuando el usuario elige un país distinto
   const handleCountryChange = (countryCode) => {
       const match = ALL_COUNTRIES.find(c => c.code === countryCode);
  if (match) setSelectedCountry(match);
};


  const next = () => {
    const field =
      current === 0
        ? showCustom ? 'purposeCustom' : 'purpose'
        : pasos[current].key;
    form.validateFields([field])
       .then(() => setCurrent(current + 1))
       .catch(() => {});
  };
  const prev = () => setCurrent(current - 1);

  // Validación en tiempo real de teléfono
  const watchedPhone = useWatch('phone', form);
  const watchedCC    = useWatch('countryCode', form);

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then(res => res.json())
      .then(data => {
            const match = ALL_COUNTRIES.find(c => c.iso === data.country_code);
        if (match) {
          setSelectedCountry(match);
          form.setFieldsValue({ countryCode: match.code });
        }
      })
      .catch(() => {
        message.warning('No se pudo detectar tu país automáticamente.');
      });
  }, [form]);
  

  useEffect(() => {
    async function checkPhone() {
      if (!watchedPhone) {
        setPhoneExists(false);
        return;
      }
      const raw  = watchedPhone.replace(/\D/g, '');
      const full = watchedCC === '52'
        ? `521${raw}`
        : `${watchedCC}${raw}`;
      const letrasQ = query(
        collection(db, 'musica'),
        where('leadPhone','==', full)
      );
      const snapL  = await getDocs(letrasQ);
      const snapD  = await getDoc(doc(db, 'leads', `${full}@s.whatsapp.net`));
      setPhoneExists(!snapL.empty || snapD.exists());
    }
    checkPhone();
  }, [watchedPhone, watchedCC, db]);

  const onFinish = async () => {
    setSubmitting(true);
    try {
      const fv = form.getFieldsValue(true);

      // 1) Validar todos los pasos
      for (let i = 0; i < pasos.length; i++) {
        let key = pasos[i].key;
        if (key === 'purpose' && fv.purpose === 'Otro') key = 'purposeCustom';
        if (!fv[key]) {
          message.error('Por favor completa todos los pasos antes de enviar.');
          setSubmitting(false);
          return;
        }
      }
      if (phoneExists) {
        message.error('No puedes enviar: este número ya está registrado.');
        setSubmitting(false);
        return;
      }

      // 2) Normalizar teléfono
      const raw      = fv.phone.replace(/\D/g, '');
      const prefix   = fv.countryCode === '52' ? '521' : fv.countryCode;
      const e164     = `${prefix}${raw}`; // ej. "5218311760335"
      const jid      = `${e164}@s.whatsapp.net`;

      // 3) Crear o actualizar lead
      const leadRef  = doc(db, 'leads', jid);
      const leadSnap = await getDoc(leadRef);
      const cfgSnap  = await getDoc(doc(db, 'config', 'appConfig'));
      const trigger  = 'MusicaLead';

      if (!leadSnap.exists()) {
        await setDoc(leadRef, {
          nombre: fv.requesterName,
          telefono: e164,
          fecha_creacion: new Date(),
          estado: 'nuevo',
          source: 'Form',
          etiquetas: [trigger],
          secuenciasActivas: [{
            trigger,
            startTime: new Date().toISOString(),
            index: 0
          }],
          unreadCount: 1,
          lastMessageAt: new Date(),
          letraIds: [],           // inicializamos array de letras
        });
      }

      // 4) Guardar la petición de letra y obtener su ID
      const letraRef = await addDoc(collection(db, 'musica'), {
        leadPhone:      e164,
        leadId:         jid, // relacion lead → letra
        purpose:        fv.purpose === 'Otro' ? fv.purposeCustom : fv.purpose,
        genre:          fv.genre,
        artist:         fv.artist,
        voiceType:      fv.voiceType,
        includeName:    fv.includeName,
        anecdotes:      fv.anecdotes,
        requesterName:  fv.requesterName,
        status:         'Sin letra',
        createdAt:      serverTimestamp(),
      });

      // 5) Añadir referencia de letra en el lead
      await updateDoc(leadRef, {
        letraIds: arrayUnion(letraRef.id)
      });

   // 6) Todo guardado: redirigir
      const redirectUrl = 'https://cantalab.com/unete-a-la-comunidad/';
      if (window.self !== window.top) {
        window.parent.location.href = redirectUrl;
      } else {
        window.location.href = redirectUrl;
      }

    } catch (err) {
      console.error(err);
      message.error('Error al procesar tu solicitud.');
      setSubmitting(false);
    }
  };

  const percent = Math.round(((current + 1) / pasos.length) * 100);

  return (
    <div
      className="formulario-cancion"
      ref={containerRef}
      style={{ maxWidth: 600, margin: '40px auto', padding: '0 20px 20px' }}
    >
      <Progress percent={percent} showInfo={false} strokeLinecap="square" style={{ marginBottom: 24 }} />
     
      <div style={{ textAlign: 'center', marginBottom: 8, color: '#888' }}>
        {current + 1} of {pasos.length}
      </div>
      <h2 style={{ fontSize: '1.75rem', textAlign: 'center', marginBottom: 24 }}>
        {pasos[current].label}
        {pasos[current].key !== 'includeName' && (
          <span style={{ color: 'red' }}> *</span>
        )}
      </h2>
      <Spin spinning={submitting} tip="Enviando" >
      <Form form={form} layout="vertical" onFinish={onFinish}>
    

        {/* Paso teléfono */}
        {pasos[current].key === 'phone' && (
           <Form.Item>
           <Input.Group compact>
             {/* Selector de país */}
             <Form.Item
               name="countryCode"
               rules={[{ required: true, message: 'Elige país' }]}
               noStyle
             >
               <Select
                 value={selectedCountry.code}
                 onChange={handleCountryChange}
                 style={{ width: '30%' }}
                 dropdownClassName="formulario-cancion-dropdown"
                 optionLabelProp="label"
               >
                 {ALL_COUNTRIES.map(c => (
                   <Option key={c.code} value={c.code} label={`${c.flag} ${c.iso}`}>
                     {c.flag} {c.iso} (+{c.code})
                   </Option>
                 ))}
               </Select>
             </Form.Item>
         
             {/* Campo de teléfono con prefijo dinámico */}
             <Form.Item
               name="phone"
               rules={[
                 { required: true, message: 'Ingresa tu número de WhatsApp' },
                 { pattern: /^\d+$/, message: 'Solo dígitos' }
               ]}
               style={{ width: '70%' }}
             >
               <Input
                 placeholder="Ej. 8133566772" 
                 maxLength={15}
                 addonBefore={`+${selectedCountry.code}`}
               />
             </Form.Item>
           </Input.Group>
         
           {phoneExists && (
             <div style={{ color: 'red', marginTop: 4 }}>
               Este número ya está registrado
             </div>
           )}
         </Form.Item>
         
        )}

        {/* Paso 0: propósito */}
        {current === 0 && (
          <>
            <Form.Item
              name="purpose"
              rules={[{ required: true, message: 'Selecciona un propósito' }]}
            >
              <Select
                dropdownClassName="formulario-cancion-dropdown"
                placeholder="Seleccione propósito"
                onChange={handleSelectChange}
              >
                {[
                  'Declarar mi amor','Decirle que la/o quiero','Desamor',
                  'Motivación y Superación Personal','Homenajes','Memoriales',
                  'Agradecer su Amistad','Despedida','Un Aniversario','Agradecer',
                  'Reconocimientos y Logros','Felicitación por Cumpleaños',
                  'Propuesta de Matrimonio','Nacimiento de un Bebé',
                  'Día de la Madre o del Padre','Otro'
                ].map(opt => <Option key={opt} value={opt}>{opt}</Option>)}
              </Select>
            </Form.Item>
            {showCustom && (
              <Form.Item
                name="purposeCustom"
                rules={[{ required: true, message: 'Escribe tu propósito' }]}
              >
                <Input.TextArea rows={3} placeholder="Escribe tu propósito" />
              </Form.Item>
            )}
          </>
        )}

        {/* Pasos 1–6 */}
        {current > 0 && pasos[current].key !== 'phone' && (() => {
          const fieldKey = pasos[current].key;
          const rules = fieldKey === 'includeName'
            ? []
            : [{ required: true, message: 'Este campo es requerido' }];

          return (
            <Form.Item name={fieldKey} rules={rules}>
              {fieldKey === 'genre' && (
                <Select placeholder="Selecciona un género" dropdownClassName="formulario-cancion-dropdown">
                  {[
                    'Corrido tumbado','Balada Romántica','Regional Mexicano','Pop',
                    'Corrido Norteño','Rock Pop','Reguetón','Bachata','Rap','Salsa',
                    'Rock','Cumbia','Banda','Que un experto elija por mí','Otro'
                  ].map(opt => <Option key={opt} value={opt}>{opt}</Option>)}
                </Select>
              )}
              {fieldKey === 'voiceType' && (
                <Select placeholder="Selecciona tipo de voz" dropdownClassName="formulario-cancion-dropdown">
                  {['Voz Femenina','Voz Masculina','Cualquiera'].map(opt => (
                    <Option key={opt} value={opt}>{opt}</Option>
                  ))}
                </Select>
              )}
              {['artist','includeName','requesterName'].includes(fieldKey) && (
                <Input placeholder={pasos[current].label} />
              )}
              {fieldKey === 'anecdotes' && (
                <Input.TextArea rows={3} placeholder={pasos[current].label} />
              )}
            </Form.Item>
          );
        })()}

        {/* Navegación */}
        <div style={{ marginTop: 32 }}>
          {current < pasos.length - 1 && (
            <Button type="primary" onClick={next} block size="large">
              Continuar ↵
            </Button>
          )}
          {current === pasos.length - 1 && (
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              disabled={submitting || phoneExists}
              block
              size="large"
            >
              Enviar y recibir canción 🎵
            </Button>
          )}
          {current > 0 && (
            <Button onClick={prev} block style={{ marginTop: 10 }}>
              ← Anterior
            </Button>
          )}
        </div>
        </Form>
      </Spin>
    </div>
    
  );
}
